import React, { useContext } from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { useTheme } from '@mui/material/styles';
import NRButtonProgress from '../NRButtonProgress/NRButtonProgress';
import { OrgLevelSettingsContext } from '../../pages/NRSettings/NRGeneralSettings/NROrgLevelSettingsContextWrapper';

function PDFReportSelectionModal({
  isAssetSummarySelected,
  isPQCReadinessSelected,
  isRiseAISelected,
  onAssetSummaryToggle,
  onPQCReadinessToggle,
  onRiseAIToggle,
  isGenerating,
  isRiseAIInsightsReportEnabled,
  isPQCReadinessReportEnabled,
  onGenerate,
  onCancel,
  hasSelectedReports
}) {
  const theme = useTheme();
  const { orgLevelSettings } = useContext(OrgLevelSettingsContext);

  return (
    <Box display="flex" flexDirection="column">
      <Box>
        <Typography variant="body2" sx={{ marginBottom: theme.spacing(2) }}>
          This will generate pdf reports of the selected asset, and then downloaded via the browser.
        </Typography>
        <Typography variant="body2" sx={{ marginBottom: theme.spacing(2) }}>
          Select which reports you want:
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: theme.spacing(1.5) }}>
          <FormControlLabel
            control={<Checkbox checked={isAssetSummarySelected} onChange={onAssetSummaryToggle} disabled={isGenerating} />}
            label="Asset Summary Report"
            disabled={isGenerating}
          />
          {isPQCReadinessReportEnabled && (
            <FormControlLabel
              control={<Checkbox checked={isPQCReadinessSelected} onChange={onPQCReadinessToggle} disabled={isGenerating} />}
              label="Asset PQC Readiness Report"
              disabled={isGenerating}
            />
          )}
          {isRiseAIInsightsReportEnabled && orgLevelSettings?.riseAiInsightsReportEnabled && (
            <FormControlLabel
              control={<Checkbox checked={isRiseAISelected} onChange={onRiseAIToggle} disabled={isGenerating} />}
              label="Asset RiseAI Insights Report"
              disabled={isGenerating}
            />
          )}
        </Box>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }} mt="auto" ml="auto">
        <Button variant="outlined" color="secondary" onClick={onCancel} disabled={isGenerating} sx={{ mr: 1 }}>
          Cancel
        </Button>
        <NRButtonProgress
          variant="contained"
          color="secondary"
          disabled={!hasSelectedReports || isGenerating}
          isLoading={isGenerating}
          type="button"
          label="Generate"
          onClick={onGenerate}
        />
      </Box>
    </Box>
  );
}

export default PDFReportSelectionModal;
